/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { cloneDeep } from 'lodash';

// Components
import BaseInput from 'shared/ui/components/form-components/BaseInput.vue';
import Checkbox from 'shared/ui/components/form-components/Checkbox.vue';
import GenericDocExternalPicker from 'shared/ui/components/form-components/pickers/GenericDocExternalPicker.vue';
import HtmlEditor from 'shared/ui/components/editors/html/HtmlEditor.vue';

// Constants
const DEFAULT_MAX_ITEMS = 6;

const __vue_script__ = {
    name: 'EventDetailsSection',

    components: { BaseInput, Checkbox, GenericDocExternalPicker, HtmlEditor },

    props: {
        event: {
            type: Object,
            required: true
        },

        lang: {
            type: String,
            required: true
        },

        defaultLang: {
            type: String,
            required: true
        },

        type: {
            type: String,
            required: true
        },

        value: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            showExternalPicker: this.type !== 'editorial',
            showMoreSettings: false,
            innerValue: {
                max_items: DEFAULT_MAX_ITEMS
            }
        };
    },

    watch: {
        lang(lang) {
            this.innerValue.content = this.innerValue.content || {};
            this.innerValue.content[lang] = this.innerValue.content[lang] || '';
        },

        value: {
            immediate: true,
            deep: true,
            handler(value) {
                this.innerValue = cloneDeep(value);
            }
        }
    },

    methods: {
        emit() {
            this.$emit('input', this.innerValue);
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"event-details-section"},[_vm._t("top-header"),_c('div',{staticClass:"section-configuration"},[_c('validation-provider',{attrs:{"slim":true,"name":"description"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('html-editor',{attrs:{"blockquote":true,"enable-custom-bstg-links":false,"errors":errors,"event-id":_vm.event._id,"extras":false,"images":true,"links":true,"name":"description"},on:{"input":_vm.emit},model:{value:(_vm.innerValue.content[_vm.lang]),callback:function ($$v) {_vm.$set(_vm.innerValue.content, _vm.lang, $$v)},expression:"innerValue.content[lang]"}})]}}])}),(_vm.showExternalPicker)?_c('generic-doc-external-picker',{attrs:{"event-id":_vm.event._id,"fp-type":_vm.type,"placeholder":_vm.$t(("registration.configuration.form.placeholders." + _vm.type)),"multiple":true,"timezone":_vm.event.timezone,"show-deleted-docs":true,"sortable":_vm.type !== 'session',"name":"ext"},on:{"input":_vm.emit},model:{value:(_vm.innerValue.fp_ext_ids),callback:function ($$v) {_vm.$set(_vm.innerValue, "fp_ext_ids", $$v)},expression:"innerValue.fp_ext_ids"}}):_vm._e(),_c('div',{staticClass:"more-settings",class:{ in: _vm.showMoreSettings }},[(_vm.showMoreSettings)?_c('div',{staticClass:"settings-wrapper"},[_c('checkbox',{attrs:{"name":"showInNav","label":_vm.$t('registration.configuration.form.sections.show_in_nav'),"hint":_vm.$t('registration.configuration.form.sections.show_in_nav_hint')},on:{"input":_vm.emit},model:{value:(_vm.innerValue.has_anchor),callback:function ($$v) {_vm.$set(_vm.innerValue, "has_anchor", $$v)},expression:"innerValue.has_anchor"}}),(_vm.type === 'session')?_c('base-input',{staticClass:"small-input",attrs:{"label":_vm.$t('registration.configuration.form.sections.collapse_items'),"hint":_vm.$t('registration.configuration.form.sections.collapse_items_hint'),"type":"number","name":"maxItems"},on:{"input":_vm.emit},model:{value:(_vm.innerValue.max_items),callback:function ($$v) {_vm.$set(_vm.innerValue, "max_items", $$v)},expression:"innerValue.max_items"}}):_vm._e()],1):_vm._e(),_c('a',{staticClass:"has-action",on:{"click":function($event){_vm.showMoreSettings = !_vm.showMoreSettings}}},[_vm._v(_vm._s(_vm.$t(("registration.configuration.form." + (_vm.showMoreSettings ? 'less' : 'more') + "_settings")))),_c('i',{staticClass:"ic-chevron-down"})])])],1)],2)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "EventDetailsSection.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__